import React from "react";
import ContactModal from "../ContactModal/ContactModal";
import "./style.css";

const Contacts = () => {
  return (
    <div className="contactsContainer" id="contacts">
      <h2>CONTACTS</h2>
      <div className="mapContainer">
        <div>
          <iframe
            title="map"
            src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d3944.339864725028!2d115.1354966!3d-8.659191!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2dd24733326c155b%3A0x48816c8bd903c5a0!2sFuntastic%20Gymnastic!5e0!3m2!1sen!2sid!4v1695269118343!5m2!1sen!2sid"
            width={window.innerWidth > 600 ? "600" : "100%"}
            height={window.innerWidth > 600 ? "100%" : "380"}
            allowfullscreen=""
            loading="lazy"
            referrerpolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>
        <ContactModal
          title="become a member"
          name="name*"
          phone="phone (WhatsApp)*"
          email="email"
          type="email"
        />
      </div>
    </div>
  );
};

export default Contacts;
